import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BuildingFloorViewComponent } from './building-floor-view.component';



@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
  ],

  declarations: [BuildingFloorViewComponent],
  exports: [BuildingFloorViewComponent]


})
export class BuildingFloorViewModule { }
